import { ApiClient, ResponseType } from './ApiClient';

export class NotificationApi {
    private apiClient: ApiClient;

    constructor() {
        this.apiClient = new ApiClient('/api/notification');
    }

    public getVisitorCountryCode(params: { url?: string } = {}): Promise<string> {
        return this.apiClient.get<string>('GetCountry', params, ResponseType.Text);
    }
}

// Export a single shared instance
export const notificationApi = new NotificationApi();